import { PackageDepartmentEnum } from "../../__generated__/graphql";

/** Lowercase display labels for service departments, for use mid-sentence. */
export const DEPARTMENT_LABELS: Record<PackageDepartmentEnum, string> = {
  [PackageDepartmentEnum.Aircon]: "aircon servicing",
  [PackageDepartmentEnum.Babysitter]: "babysitting",
  [PackageDepartmentEnum.CarpetUpholstery]: "carpet & upholstery cleaning",
  [PackageDepartmentEnum.CarWash]: "car wash",
  [PackageDepartmentEnum.DeepCleaning]: "deep cleaning",
  [PackageDepartmentEnum.ElderCare]: "elder care",
  [PackageDepartmentEnum.Handyman]: "handyman services",
  [PackageDepartmentEnum.HomeBeauty]: "home beauty",
  [PackageDepartmentEnum.HomeCleaning]: "home cleaning",
  [PackageDepartmentEnum.Massage]: "massage",
  [PackageDepartmentEnum.OfficeCleaning]: "office cleaning",
  [PackageDepartmentEnum.PestControl]: "pest control",
  [PackageDepartmentEnum.PetCare]: "pet care",
  [PackageDepartmentEnum.Security]: "security services",
};
